<template lang="pug">

	div(v-bind:class="{ 'camadas-tree': level == 0 }")

		div.camadas-tree-item(v-if="level > 0",
				@click="onClick()",
				:class="[{ \
					'camadas-tree-item-active': (isGrupo && open) || (!isGrupo && model.habilitado), \
					'camadas-tree-grupo': isGrupo, \
					'camadas-tree-camada': !isGrupo, \
					'last-item': last }, \
					model.cssClass ? model.cssClass : '']")

			//- Indentações de acordo com o nível na árvore

			div.camadas-indent(v-for="showTreeLine in indents")
				div.tree-line(v-if="showTreeLine")
				
			div.camadas-indent.last-indent(v-if="level > 1")
				div.tree-line
				hr

			//- Visualização de grupo

			div.camadas-tree-item-nome(v-if="isGrupo")
				i.fa(:class="{ 'fa-folder-open': open, 'fa-folder': !open }")
				| {{ model.nome }}

				div.complementar-tree-line(v-show="open && hasChildren")

			//- Visualização de camada

			div.dtable-cell.camadas-tree-item-nome(v-if="!isGrupo")
			
				label.custom-control.custom-checkbox
					input.custom-control-input(type='checkbox',
							@change="onCamadaCheck()", 
							:checked="model.habilitado")
					span.custom-control-indicator
					span.custom-control-description {{ model.nome }}

		//- Elementos descendentes

		div.camadas-tree-children(:class="{'closed': !open}")

			camadas-tree(v-if="model.grupos", 
				v-for="(grupo, index) in model.grupos", 
				:model="grupo",
				:grupo-pai="model"
				:key="grupo._key",
				:ref="'tree-item-' + grupo._key"
				:level="level + 1",
				:first="index === 0",
				:last="index === model.grupos.length - 1 &&  model.camadas.length === 0",
				:indents="childIndents",
				:emitter="eventEmitter",
				@open="onOpen")

			camadas-tree(v-if="model.camadas", 
				v-for="(camada, index) in model.camadas", 
				:model="camada",
				:grupo-pai="model"
				:key="camada.id"
				:level="level + 1",
				:first="index === 0",
				:last="index === model.camadas.length - 1",
				:indents="childIndents",
				:emitter="eventEmitter",
				@open="onOpen")

</template>

<script>

import { mapMutations } from 'vuex';

export default {
	name: 'CamadasTree',

	props: {
		model: Object,
		grupoPai: Object,
		emitter: Object,
		first: Boolean,
		last: Boolean,
		level: {
			type: Number,
			default: 0
		},
		indents: Array
	},

	data () {

		return {
			open: this.level === 0
		};
	},

	computed: {
		
		isGrupo () {
			return !this.model.geoServer && !this.model.tipoGeometria;
		},

		eventEmitter () {
			return this.emitter || this;
		},

		childIndents () {
			if (this.level <= 1) return null;
			return this.indents ? _.concat(this.indents, !this.last) : [!this.last];
		},

		hasChildren () {
			return this.isGrupo && (
				(this.model.grupos && this.model.grupos.length > 0) ||
				(this.model.camadas && this.model.camadas.length > 0));
		}
	},

	mounted () {
		if (!this.isGrupo && this.model.habilitado) {
			this.$emit('open');
		}
	},

	methods: {
		onOpen () {
			this.open = true;
			this.$emit('open');
		},

		onClick () {

			if (this.isGrupo) {
				this.open = !this.open;
			}
		},

		onCamadaCheck () {

			if (!this.model.habilitado) {
				this.ativarCamada(this.model);
			} else {
				this.desativarCamada(this.model);
			}
		},

		getEvent (name) {

			return (this.isGrupo) ? name + 'Grupo' : name + 'Camada';
		},

		callRecursive (callback) {

			if (this.$children) {

				for (let child of this.$children) {
					
					if (child && child.$options && child.$options.name === 'CamadasTree') {
						child.callRecursive(callback);
					}
				}
			}

			callback(this);
		},
		
		refresh () {

			this.callRecursive((node) => {

				node.$forceUpdate();
			});
		},

		expandAll () {

			this.callRecursive((node) => {

				if (node.level > 0) {
					node.open = true;
				}
			});
		},

		collapseAll () {

			this.callRecursive((node) => {

				if (node.level > 0) {
					node.open = false;
				}
			});
		},

		...mapMutations([
			'ativarCamada',
			'desativarCamada'
		])
	}
};
</script>

<style lang="scss">

@import "../../styles/variaveis";

// Computed
$camadas-icon-width: $camadas-icon-font-size + $camadas-icon-margin-right;

.camadas-tree {
	
	margin-left: -15px;
	margin-right: -15px;

	.camadas-tree-item {
		padding-right: 15px;
    	padding-left: 15px;

		display: block; 
		width: 100%; 
		box-sizing: border-box;
		text-overflow: ellipsis;

		&:hover {
			background-color: $camadas-hover-bg-color;
			
			.camadas-tree-item-nome {
				color: $camadas-hover-nome-color;
			}
		}
		
		&.camadas-tree-grupo {

			cursor: pointer;
			text-indent: -$camadas-icon-width;
			
			.camadas-tree-item-nome {
				padding-left: $camadas-icon-width;
			}

			// Linha que liga a pasta a continuação da linha do elemento abaixo
			.complementar-tree-line {
				border-left: solid $camadas-tree-line-width $camadas-tree-line-color;
				width: $camadas-tree-line-width;
				bottom: 0;
				position: absolute;
				top: $camadas-icon-font-size + 7px;
				left: $camadas-tree-line-margin-left;
			}

			&.grupo-camadas-usuario .camadas-tree-item-nome i {
				color: $camadas-usuario-icon-color;
			}
		}

		.camadas-tree-item-nome {
			font-size: $camadas-nome-fonte-size;
			color: $camadas-nome-color;
			display: table-cell;
			text-overflow: ellipsis;
			padding-top: $camadas-nome-top-bottom-padding;
			padding-bottom: $camadas-nome-top-bottom-padding;
			position: relative;
			
			i {
				float: left;
				padding-top: $camadas-icon-padding-top;
				height: 100%;
				width: $camadas-icon-width;
				font-size: $camadas-icon-font-size;
				color: $camadas-icon-color;
			}
		}

		&.camadas-tree-item-active {
			
			&.camadas-tree-grupo .camadas-tree-item-nome {
				color: $camadas-active-nome-grupo-color;
			}

			&.camadas-tree-camada .camadas-tree-item-nome {
				color: $camadas-active-nome-camada-color;
			}

			.camadas-tree-item-nome i {
				color: $camadas-active-icon-color;
			}
		}

		label.form-check-label {
			display: block;
		}

		.camadas-indent {
			display: table-cell; 
			box-sizing: border-box;
			width: $camadas-indent-size;
			position: relative;
			
			.tree-line {
				border-left: solid $camadas-tree-line-width $camadas-tree-line-color;
				position: absolute;
				top: 0;
				bottom: 0;
				margin: 0;
				left: $camadas-tree-line-margin-left;
				height: 100%;
				display: block;
				width: 100%;
				min-height: 1px;
			}

			hr {
				position: absolute;
				margin: 0;
				right: 0;
				top: $camadas-tree-hline-top;
				left: $camadas-tree-line-margin-left;
				border-top: solid $camadas-tree-line-width $camadas-tree-line-color;
			}

		}

		&.last-item {

			.camadas-indent.last-indent {
				.tree-line {
					height: $camadas-tree-hline-top + $camadas-tree-line-width;
				}
			}
		}
	}

	.camadas-tree-children {

		&.closed {

			display: none;
		}
	}
}

</style>



// WEBPACK FOOTER //
// CamadasTree.vue?040ec692